<template>
    <nav class="navbar navbar-expand-md navbar-main bg-blur fixed-top p-0" :class="{
        'navbar-light': !isDark,
        'navbar-dark': isDark,
        'cloudy': isWriting,
        'd-none': isHide,
    }">
        <div class="container-fluid">
            <router-link class="navbar-brand mincho" to="/">
                <img :src="favicon" class="favicon d-inline-block align-top" :alt="$store.state.bookshelf_name">
                <h1 class="inherit" v-html="$filters.ruby($store.state.bookshelf_name)"></h1>
            </router-link>
            <div class="d-sm-block d-md-none">
                <div class="btn-group" v-if="$store.state.user && $store.state.user.id">
                    <a href="#" class="text-sp mx-2" role="button" @click.prevent="showActivities()">
                        <i class="far fa-bell"></i>
                        <span class="badge badge-danger badge-pill" v-if="notification_count">{{notification_count}}</span>
                    </a>
                </div>
                <button class="navbar-toggler" type="button"
                    @click="$emit('showSidemenu')"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Sidemenu Control">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item btn-group d-none d-md-flex" v-if="$store.state.user && $store.state.user.id">
                        <a href="#" class="nav-link mx-2 no-bg" data-done-toggle="dropdown" role="button" @click.prevent="showActivities()">
                            <i class="far fa-bell"></i>
                            <span class="badge badge-danger badge-pill" v-if="notification_count">{{notification_count}}</span>
                        </a>
                    </li>
                    <li class="nav-item d-none d-md-flex" v-if="!inSecurity">
                        <div class="my-2 input-group mr-sm-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                            <input type="search"
                                class="form-control form-control-sm"
                                v-model="keywords"
                                name="keyword"
                                placeholder="書籍検索"
                                @keydown.enter="search" />
                        </div>
                    </li>
                    <template v-if="!$store.state.user || !$store.state.user.id">
                        <li class="nav-item" v-if="$store.state.subdomain && !$store.state.is_isolated">
                            <a class="nav-link" :href="`//www${$store.state.base_domain}/`">
                                <i class="fas fa-running"></i>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" @click.prevent="$emit('showLayout')">
                                <i class="fas fa-palette"></i>
                            </a>
                        </li>
                        <li class="nav-item" v-if="!$store.state.is_isolated">
                            <a class="nav-link" :href="`//www${$store.state.base_domain}/login`">ログイン</a>
                        </li>
                        <li class="nav-item" v-if="!$store.state.is_isolated">
                            <a class="nav-link" :href="`//www${$store.state.base_domain}/register`">ユーザー登録</a>
                        </li>
                    </template>
                    <template v-else>
                        <li class="nav-item">
                            <a class="nav-link dont-close no-bg" :class="{'text-danger': isImpersonate}" href="#" role="button" aria-haspopup="true" aria-expanded="false" @click.prevent="$emit('showSidemenu')">
                                <i class="fas fa-bars"></i>
                                {{$store.state.user.name}}
                                <i class="fas fa-user-secret" v-if="isImpersonate"></i>
                            </a>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </nav>
</template>

<style scoped lang="scss">
.text-alert {
    color: crimson;
    text-shadow: 0 0 .3rem crimson;
    &:hover {
        text-shadow: 0 0 .6rem #ec0937;
    }
}
.recent-menu {
    min-width: 370px;
    max-height: calc(100vh - 43px);
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
}
.recent-empty {
    height: 15rem;
    text-align: center;
    .empty-icon {
        display: inline-block;
        margin: 4rem auto 0;
        font-size: 3rem;
        width: 48px;
    }
}
.activity {
    font-size: .8rem;
}
.bg-windows {
    backdrop-filter: none;
    background-color: rgba(255, 255, 255, 0.9);
}
.n-zouge { background-color: #f8f4e6; }
.n-sakura { background-color: #fef4f4; }
.favicon {
    width: 30px;
    height: 30px;
    border-radius: .4rem;
}
.navbar-brand {
    max-width: calc(100vw - 180px);
    overflow: hidden;
    margin-right: 0.5rem;
}
.text-sp {
    color: #222;
}
.navbar-dark {
    .text-sp {
        color: rgba(255, 255, 255, 0.5);
    }
}
.navbar-toggler {
    border-radius: .5rem;
}
.no-bg {
    background-color: transparent !important;
}
@media screen and (max-width: 770px) {
    .navbar-brand {
        font-size: 1rem;
    }
}
</style>

<script>
export default {
    props: {
        isWriting: {
            default: false,
        }
    },
    data() {
        return {
            keywords: "",
            activities: [],
            notifications: [],
            unread: 0,
            isHide: false,
            notification_count: 0,
        }
    },
    methods: {
        getAuth() {
            this.$store.dispatch("login").then(rc => {
                if (rc?.id) {
                    this.connectChannel();
                    this.reaggregate();
                }
            });
        },
        search(ev) {
            if (ev.keyCode !== 13) return;
            if (!this.keywords.length) return;
            this.$router.push("/search?keywords=" + encodeURI(this.keywords));
            $('.navbar-collapse').collapse('hide');
        },
        showActivities() {
            this.$emit("showActivities");
        },
        aggregate() {
            axios.get("/notification/aggregate").then(res => {
                this.notification_count = res.data;
            }).catch(err => { alert.err(err) });
        },
        reaggregate() {
            axios.get("/notification/reaggregate").then(res => {
                this.notification_count = res.data;
            }).catch(err => { alert.err(err) });
        },
        connectChannel() {
            Echo.channel("notify").listen("Activity\\PublicActivity", (e) => {
                this.reaggregate();
            });
            Echo.channel("notify." + this.$store.state.user.id).listen("Activity\\PrivateActivity", (e) => {
                this.aggregate();
            });
        },
        refreshStatus() {
            if (this.$route.path.match(/^\/author\/page\/\d+|preview|live/)) {
                this.isHide = true;
            } else {
                this.isHide = false;
            }
        }
    },
    computed: {
        favicon() {
            if (this.$store.state.favicon) {
                return this.$store.state.favicon;
            }
            return "/favicon.png";
        },
        notices() {
            return (this.activities?.length || 0);
        },
        isImpersonate() {
            return this.$store.state.user?.impersonate;
        },
        isDark() {
            if (this.$store.state?.background_color.match(/black|doom|rome|jupiter|space/)) {
                return true;
            }
            return false;
        },
        inSecurity() {
            if (this.$route.path.match(/^\/mypage\/account/)) {
                return true;
            }
            return false;
        }
    },
    watch: {
        $route(n, o) {
            this.refreshStatus();
        }
    },
    mounted() {
        this.getAuth();
        this.refreshStatus();
    }
}
</script>